const dealItems = {
  category: "Transaktionsberatung",
  list: [{ id: "sell_side", to: "Risikomanagement", label: "Sell Side" },
  { id: "buy_side", to: "Compliance", label: "Buy Side" },
  { id: "capital", to: "Internes", label: "Finanzierung / Kapitalbeschaffung", },
  { id: "market", to: "Governance", label: "Börsengang (IPO)" },
  { id: "m_and_a", to: "Compliance", label: "Unternehmensnachfolge" },
  { id: "profiling", to: "Internes", label: "Unternehmensbewertung" },
  { id: "readiness", to: "Governance", label: "Exit- / IPO-Readiness" },
  ]
};


const esgItems = {
  category: "ESG-Beratung",
  list: [{ id: "ESG", to: "Risikomanagement", label: "ESG-Beratung" },
  { id: "status_quo", to: "Risikomanagement", label: "ESG status quo" },
  { id: "reporting", to: "Compliance", label: "ESG Reporting & Communication" },
  { id: "strategy", to: "Internes", label: "ESG Strategy" },
  { id: "sustainability", to: "Governance", label: "Financing Sustainability" },
  { id: "opportunity", to: "Compliance", label: "ESG Opportunity (ESG Data & AI for Impact)" },
  { id: "kooperationspartner", to: "Internes", label: "Kooperationspartner" },
  { id: "esg_ebook", to: "Governance", label: "ESG-Whitepaper" },
  ]
};

const fokusthemaItems = {
  category: "Immobilienwirtschaft",
  list: [{ id: "Immobilienverwaltung", to: "Risikomanagement", label: "Beratung" },
  { id: "asset", to: "Compliance", label: "Digitalisierte Immobilienverwaltung" },
  { id: "orgacheck", to: "orgacheck", label: "Orga Check-Konzept" },
  { id: "ebookdownloads", to: "Internes", label: "Beratungsprodukte", },
  { id: "ebook", to: "Ebook", label: "Ebook Downloads", },

  ]
};
const corpAdv = {
  category: "Strategische Beratung",
  list: [{ id: "Unternehmenssteuerung", to: "Risikomanagement", label: "Unternehmenssteuerung" },
  ]
};





export function getSideIndexList(name) {

  switch (name) {
    case "deal": return dealItems;
    case "fokus": return fokusthemaItems;
    case "esg": return esgItems;
    case "corpadv": return corpAdv;
    default: break;

  }


}